'use client'

import { useContext } from 'react'
import { WishlistContext } from '@/lib/commerce/providers/WishlistProvider'
import type { WishlistContextValue } from '@/lib/commerce/types/wishlist'

export function useWishlist(): WishlistContextValue {
  const ctx = useContext(WishlistContext)
  if (!ctx) throw new Error('useWishlist must be used within <WishlistProvider>')
  return ctx
}
